import ColumnFactory from '@/Factories/ColumnFactory';
import ComponentManager from '@/Management/ComponentManager';
import LabelViewModelType from '@/ViewModels/Controls/LabelViewModel';
import ImageViewModelType from '@/ViewModels/Controls/ImageViewModel';
import LabelType from '@/Controls/Label';
import ImageType from '@/Controls/Image';

export default class EncryptedColumnFactory extends ColumnFactory {

    private LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModelType>('LabelViewModel');
    private ImageViewModel = ComponentManager.getViewModel<typeof ImageViewModelType>('ImageViewModel');
    private Label = ComponentManager.getControl<typeof LabelType>('Label');
    private Image = ComponentManager.getControl<typeof ImageType>('Image');
    public static isPlainText = false;
    public static isJQueryElement = true;

    private imageViewModel: ImageViewModelType;
    private image: ImageType;
    private labelViewModel: LabelViewModelType;
    private label: LabelType;
    private jQueryControl: JQuery<HTMLElement>;

    constructor(private params: any) {
        super(params);
    }

    public getValue(): any {
        if (this.jQueryControl != null)
            return this.jQueryControl;

        if (this.raw === '~ N.A. ~') {
            this.imageViewModel = new this.ImageViewModel({
                source: 'lock.png',
                alternativeText: new this.LabelViewModel({
                    ergName: 'LOCKEDOVERLAY_LABEL',
                })
            });

            this.image = new this.Image(this.imageViewModel);

            this.labelViewModel = new this.LabelViewModel({
                ergName: 'LOCKEDOVERLAY_LABEL'
            });

            this.label = new this.Label(this.labelViewModel);

            const imageTuple = this.image.getTuple();
            const labelTuple = this.label.getTuple();

            this.jQueryControl = $('<div class="c-encryptedcolumn">')
                .append(imageTuple.control).append(labelTuple.control);

            return this.jQueryControl;
        } else {
            return this.raw;
        }
    }
}

ComponentManager.setFactory('EncryptedColumn', EncryptedColumnFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');